import React, { FC } from 'react';
import '@components/shared/Agile/AgileBase.css';
import Text from '@amzn/meridian/text';
import { useAppSelector } from '@store/hooks';
import { selectProgram } from '@store/slices/programSlice';

const WelcomePage: FC = () => {
  const programType = useAppSelector(selectProgram);
  const welcomeMessage = `Welcome to ${programType}`;
  return (
    <div className="agile-home-container">
      <Text type="h600" alignment="center">
        {welcomeMessage}
      </Text>
    </div>
  );
};
export default WelcomePage;
